module.exports = __webpack_public_path__ + "assets/img/extractionTarot.6c3c45ac.png";